const colors = {
    green: '#006d67',
    greenLight: '#e8f2f0',
    gold: '#bea107',
    goldLight: '#faf8f3',
    black: '#000',
    white: '#fff',
    greyLight: '#e6e6e6',
    grey: '#999',
    greyTransparent: 'rgba(255, 255, 255, 0.4)',
    greyDark: '#666',
    greyBlack: '#333',
    invalid: 'rgba(255, 0, 0, .8)'
}

export default colors;